"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var reserveOnlineMessageStyles = styles_1.makeStyles(function (theme) { return ({
    titleContainer: {
        display: 'flex',
    },
    icon: {},
    title: {
        margin: theme.spacing(2) + " 0",
    },
    description1: {
        margin: theme.spacing(2) + " 0",
    },
    description2: {},
    email: {},
}); }, { name: 'GqlCheckout_ConfirmationReserveOnline' });
exports.default = reserveOnlineMessageStyles;
